module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ExtraBold-92273e3914d0ebd0cc2b00154cb62905.woff";